const Config = {
    app: {
        baseURL: process.env.BASE_URL,
        nodeEnv: process.env.NODE_ENV,
    },
    diceAPI: {
        baseURL: process.env.VUE_APP_DICE_API_BASE_URL,
        basicAuth: {
            username: process.env.VUE_APP_DICE_API_USERNAME,
            password: process.env.VUE_APP_DICE_API_PASSWORD,
        },
    },
    atlasAPI: {
        baseURL: process.env.VUE_APP_ATLAS_API_BASE_URL,
        basicAuth: {
            username: process.env.VUE_APP_ATLAS_API_USERNAME,
            password: process.env.VUE_APP_ATLAS_API_PASSWORD,
        },
    },
    hermesAPI: {
        baseURL: process.env.VUE_APP_HERMES_API_BASE_URL,
        basicAuth: {
            username: process.env.VUE_APP_HERMES_API_USERNAME,
            password: process.env.VUE_APP_HERMES_API_PASSWORD,
        },
    },
    sentry: {
        enabled: process.env.VUE_APP_SENTRY_ENABLED === "true",
        key: process.env.VUE_APP_SENTRY_KEY,
        projectId: process.env.VUE_APP_SENTRY_PROJECT_ID,
    },
};

module.exports = Config;